import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

const csharp = `var client = new HttpClient();
var request = new HttpRequestMessage(
  HttpMethod.Get,
  $"{baseUrl}/api/External/GetEvents?FilterValue=&FilterType=0&EventTypes=&Skip=0&Take=50");
request.Headers.Add("Authorization", "Bearer <access_token>");
var response = await client.SendAsync(request);
response.EnsureSuccessStatusCode();
Console.WriteLine(await response.Content.ReadAsStringAsync());
`;

function HTTPCRC() {
  return (
    <Highlight {...defaultProps} theme={theme} code={csharp} language="csharp">
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default HTTPCRC;
